import { TextSpan } from '../../../Atoms/Text';
import { LoadError } from '../LoadError';

export interface SupplierCatalogStatusProps {
  loading: boolean;
  failed: boolean;
  onRetry: () => void;
}

/** Without the catalog every name reads as unlisted, so say why the search shows nothing. */
export const SupplierCatalogStatus = ({ loading, failed, onRetry }: SupplierCatalogStatusProps) => {
  if (failed) {
    return (
      <LoadError
        subject="the supplier catalog"
        consequence="a name typed now is saved without a catalog link"
        onRetry={onRetry}
      />
    );
  }
  if (!loading) return null;
  return (
    <TextSpan
      size="xs"
      color="grey6">
      Loading the UPSTACK supplier catalog…
    </TextSpan>
  );
};
